"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme_1 = require("../../theme");
const constants_1 = require("../../../elements/elements/Code/constants");
const genStyle_1 = require("../genStyle");
const styleSchema = {
    button: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.neutralColor }),
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.hoverColor }),
    },
    defaultIcon: {
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryTextColor }),
    },
    successIcon: {
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryTextColor }),
    },
    icon: {
        height: (0, genStyle_1.genStyle)({ value: 40 }),
        width: (0, genStyle_1.genStyle)({ value: 40 }),
        borderRadius: (0, genStyle_1.genStyle)({ value: 100 }),
    },
};
exports.default = { [constants_1.TYPE]: { style: styleSchema, font: {}, feedback: {} } };
